import { useEffect, useState } from 'react'
import { fonts } from 'types'
import { fontScale, fontTitle, fontFamily as getFontFamily } from 'utils'

type FontInfo = {
    fontScale: number
    index: number
    label: string
}

export function useFontInfo(fontFamily: string) {
    const defaultState = { fontScale: 1, index: -1, label: fontFamily }
    const [state, setState] = useState<FontInfo>(defaultState)

    useEffect(() => {
        const font = fonts.find((f) => getFontFamily(f) === fontFamily)

        if (font) {
            setState({
                fontScale: fontScale(font),
                index: fonts.indexOf(font),
                label: fontTitle(font),
            })
        } else {
            setState(defaultState)
        }
    }, [fontFamily])

    return state
}
